import { SearchOrderBinded } from '../../models/Orders_v2';
import { BillConceptos, BillConceptTax, FiscalpopCFDI } from '../../models/Factura';

// SAT Impuesto codes → internal tax types
const IMPUESTO_CODE_TO_TYPE: { [code: string]: 'iva' | 'ieps' | 'isr' } = {
    '001': 'isr',
    '002': 'iva',
    '003': 'ieps',
};

type SourceTraslado = FiscalpopCFDI['json']['cfdi:Impuestos']['cfdi:Traslados']['cfdi:Traslado'][0];

export function refundToConceptos(
    orderBilled: SearchOrderBinded,
    cfdiResponse: FiscalpopCFDI
): BillConceptos[] {
    const isGlobal = !!cfdiResponse.json["cfdi:InformacionGlobal"];
    const conceptos = cfdiResponse.json["cfdi:Conceptos"]["cfdi:Concepto"];

    // Global bill: each Concepto is an individual order → match by NoIdentificacion.
    // Standard bill: each Concepto is a product, so we take the order-level
    // aggregated traslados instead.
    let sourceTraslados: SourceTraslado[] = [];
    if (isGlobal) {
        const matchingConcepto = conceptos.find(c => c["@"].NoIdentificacion === orderBilled.order.orderId);
        if (matchingConcepto) {
            sourceTraslados = matchingConcepto["cfdi:Impuestos"]?.["cfdi:Traslados"]?.["cfdi:Traslado"] || [];
        } else {
            console.warn('[refundToConceptos] No matching concepto for orderId on global bill; falling back to bill-level traslados:', orderBilled.order.orderId);
            sourceTraslados = cfdiResponse.json["cfdi:Impuestos"]?.["cfdi:Traslados"]?.["cfdi:Traslado"] || [];
        }
    } else {
        sourceTraslados = cfdiResponse.json["cfdi:Impuestos"]?.["cfdi:Traslados"]?.["cfdi:Traslado"] || [];
    }

    const impuestos: BillConceptTax[] = sourceTraslados.map(t => {
        const attrs = t["@"];
        const type = IMPUESTO_CODE_TO_TYPE[attrs.Impuesto] || 'iva';
        const isExento = attrs.TipoFactor === 'Exento';
        const isCuota = attrs.TipoFactor === 'Cuota';
        const tax: BillConceptTax = {
            type,
            retencion: false,
            exento: isExento,
        };
        if (isCuota) {
            tax.cuota = parseFloat(attrs.TasaOCuota);
        } else if (isExento) {
            tax.tasa = 0;
        } else {
            tax.tasa = parseFloat(attrs.TasaOCuota);
        }
        return tax;
    });

    const iva = impuestos.find(t => t.type === 'iva');
    const ieps = impuestos.filter(t => t.type === 'ieps');
    const ivaTasa = iva?.exento ? 0 : (iva?.tasa || 0);
    const iepsTasa = ieps.reduce((p, c) => p + (c.tasa || 0), 0);
    const iepsCuota = ieps.reduce((p, c) => p + (c.cuota || 0), 0);

    // grandTotal includes all taxes — strip them to get the pre-tax unitario.
    // Order of operations mirrors how the CFDI is built: subtotal → +IEPS → +IVA.
    const grandTotal = orderBilled.order.proceeds?.grandTotal?.amount || 0;
    const preIva = grandTotal / (1 + ivaTasa);
    const preIeps = (preIva - iepsCuota) / (1 + iepsTasa);
    const valorUnitario = Math.round(preIeps * 100) / 100;

    return [{
        claveProdServ: '84111506',
        claveUnidad: 'ACT',
        cantidad: 1,
        descripcion: 'Devolución de mercancias',
        valorUnitario,
        impuestos,
    }];
}
